import React, { memo } from 'react';
import {
  ListElemImage,
  ListElemText,
  ListItem,
  ListItemCell,
  ListItemCont,
} from '@pascal/pascal-core';
import moment from 'moment';
import pfCheck from '../../../assets/images/core/pf-check.png';

const RenderItem = ({ data, openCheckHash }) => {
  const { roundId, odd, startedDate } = data;
  const launchTime = new Date(`${startedDate}${startedDate.lastIndexOf('Z') < 0 ? 'Z' : ''}`);
  return (
    <ListItemCont key={roundId}>
      <ListItem>
        <ListItemCell>
          <ListElemText>{moment(launchTime).format('HH:mm')}</ListElemText>
        </ListItemCell>
        <ListItemCell>
          <ListElemText noTextTransform>x{odd}</ListElemText>
        </ListItemCell>
        <ListItemCell>
          <ListElemImage name={roundId} onClick={openCheckHash} imageSrc={pfCheck} />
        </ListItemCell>
      </ListItem>
    </ListItemCont>
  );
};

export const HighestContainerItem = memo(RenderItem);
